import { forwardRef } from 'react';
import type { ButtonHTMLAttributes, ReactNode } from 'react';
import { Spinner } from './Spinner';
import './primitives.css';

export type ButtonVariant = 'primary' | 'accent' | 'secondary' | 'ghost' | 'danger';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  leadingIcon?: ReactNode;
  trailingIcon?: ReactNode;
  loading?: boolean;
  fullWidth?: boolean;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  {
    variant = 'secondary',
    size = 'md',
    leadingIcon,
    trailingIcon,
    loading,
    fullWidth,
    disabled,
    className,
    children,
    style,
    type = 'button',
    ...rest
  },
  ref,
) {
  const classes = [
    'lm-btn',
    `lm-btn--${variant}`,
    size !== 'md' ? `lm-btn--${size}` : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      ref={ref}
      type={type}
      className={classes}
      disabled={disabled || loading}
      style={fullWidth ? { width: '100%', ...style } : style}
      {...rest}
    >
      {loading ? <Spinner size="sm" decorative /> : leadingIcon}
      {children}
      {trailingIcon}
    </button>
  );
});
